import React, { useState, useEffect} from 'react';
import Map from './components/Map';
import { useMapStore } from './store/mapStore';
import Sidebar from './components/Sidebar';
import MapControls from './components/MapControls';
import CustomerStats from './components/CustomerStats';
import Navbar from './components/Navbar';
import Header from './components/Header';
import HomePage from './components/HomePage';
import Filters from './components/Filters'
import CreateLeadSheet from './components/CreateLeadSheet';

function App() {
	const { isLoading, isSearchVisible, isHomeVisible, showFilters, setShowFilters, userPrefsLoaded } = useMapStore();
	const [sidebarOpen, setSidebarOpen] = useState(true);
	const [controlsVisible, setControlsVisible] = useState(true);
	const [apikey,setapikey] = useState('');
	const isMobile = window.innerWidth <= 800;
  const [mapKey, setMapKey] = useState(0);      // forces remount when incremented
  const [sessionExpired, setSessionExpired] = useState(false);
	const toggleControls = () => {
		setControlsVisible(!controlsVisible);
	};

  // App.jsx
  useEffect(() => {
    const refreshIfNeeded = () => {
      try {
        if (sessionStorage.getItem('salesmap_refresh_needed') === '1') {
          sessionStorage.removeItem('salesmap_refresh_needed');
          const { searchCenter, searchByLatLng } = useMapStore.getState();
          if (searchCenter?.lat && searchCenter?.lng) {
            console.log('[return] refreshing map after external form');
            searchByLatLng(searchCenter.lat, searchCenter.lng);
          }
        }
      } catch {}
    };

    // fire on first mount
    refreshIfNeeded();

    // also fire when tab/iframe becomes visible again (covers Android webview/new tab)
    const onVis = () => {
      if (document.visibilityState === 'visible') setTimeout(refreshIfNeeded, 200);
    };
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, []);

  
	useEffect(() => {
		if(import.meta.env.VITE_ENVIRONMENT=="dev"){
			console.log('Using dev creds in App.js')
			setapikey(import.meta.env.VITE_GOOGLE_MAPS_API_KEY)
		}else {
			fetch(`/env${import.meta.env.VITE_ENVIRONMENT || ""}.json`)
				.then((res) => res.json())
				.then((config) => {setapikey(config.VITE_GOOGLE_MAPS_API_KEY);}
			);
		}
	}, []);
	
	useEffect(() => {
	  const alreadyReloaded = localStorage.getItem('canvas_reload');
		if (!alreadyReloaded) {
			localStorage.setItem('canvas_reload', 'true');
			const url = new URL(window.location.href);
			url.searchParams.set('r', Date.now());
			window.location.href = url.toString();
		}
	}, []);
	
	useEffect(() => {
		if (localStorage.getItem('canvas_reload')) {
			sessionStorage.clear();
			useMapStore.getState().reset();
			localStorage.removeItem('map-store');
		}
	}, []);

  useEffect(() => {
    useMapStore.getState().loadUserPrefs();
  }, []);
  
	useEffect(() => {
		const handleBeforeUnload = () => {
			useMapStore.getState().reset();       // Clear Zustand store
			localStorage.removeItem('map-store'); // Optional: clear persisted Zustand store if you use persist
		};

		window.addEventListener('beforeunload', handleBeforeUnload);
		return () => window.removeEventListener('beforeunload', handleBeforeUnload);
	}, []);

  // Listen for the auth-loss event fired by api.js
  useEffect(() => {
    const onExpired = () => setSessionExpired(true);
    window.addEventListener('sysco:session-expired', onExpired);
    return () => window.removeEventListener('sysco:session-expired', onExpired);
  }, []);

  

  return (
    <div>
    {apikey == null || apikey == undefined || apikey == "" ?<div/>: 
    <div className="min-h-screen flex flex-col bg-gray-50 text-gray-900">
      {/*{isMobile && <Header /> header removed as part of enhancement uncomment to reinsert */}
      {/* {console.log('Rendering Main App')} */}
      {sessionExpired && (
        <div className="fixed inset-0 z-[1000] bg-white/85 flex items-center justify-center p-6">
          <div className="max-w-md w-full bg-white border border-gray-200 rounded-2xl shadow-lg p-6 text-center">
            <h2 className="text-xl font-semibold text-gray-800">Session expired</h2>
            <p className="mt-3 text-gray-600">
              Your sign-in session is no longer valid. Please return to Salesforce and relaunch Sales Map.
            </p>
            </div>
          </div>
      )}
      <div className="flex flex-1 relative">
        <Navbar />
        
        <div className="flex-1 relative md:ml-[var(--left-sidebar-width)]">
          <div className="absolute top-4 right-4 z-10">
            <CustomerStats />
          </div>
          
          {controlsVisible && !isMobile && userPrefsLoaded && (
            <div className="absolute top-4 left-4 z-30">
              <MapControls />
            </div>
          )}
          
          <button 
            onClick={toggleControls}
            className="absolute top-[120px] left-4 z-20 bg-white p-2 rounded-full shadow-md hover:bg-gray-50"
            style={{ display: controlsVisible ? 'none' : 'block' }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z"></path>
              <path d="M17 4a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"></path>
              <path d="M19 11h2m-1 -1v2"></path>
            </svg>
          </button>
          
          <div className="absolute inset-0">
            {isLoading && (
              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 z-20">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
              </div>
            )}
        <Map key={mapKey} apikey={apikey} />          </div>
          
          {(isSearchVisible || !isMobile) && (
            <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
          )}

          {isHomeVisible && isMobile && <HomePage />}
        </div>
      </div>
    </div>}
    {/* mobile Filters overlay */}
    {showFilters && isMobile && (
      <div className="fixed inset-0 z-50 bg-white flex flex-col">
        {/*  keep z‑40: above Map (z‑10) and CustomerStats (z‑10) */}
        <Filters onClose={() => setShowFilters(false)}
        onFiltersApplied={() => setMapKey(k=>k+1)} />
      </div>
)}

<CreateLeadSheet />


</div>
  );
}

export default App